if (!customElements.get('product-add-to-cart-sticky')) {
class ProductAddToCartSticky extends HTMLElement {
    constructor() {
        super();
        this.handleScroll = this.handleScroll.bind(this);
        this.handleVariantChange = this.handleVariantChange.bind(this);
        this.sectionId = this.dataset.section;
    }

    connectedCallback() {
        this.targetElement = document.querySelector('[id^="ProductSubmitButton-"]');
        this.footerElement = document.querySelector('footer');
        this.stickyAtcVariantInput = this.querySelector('.product-variant-id');

        window.addEventListener("scroll", this.handleScroll, { passive: true });
        window.addEventListener("resize", this.handleScroll);
        this.handleScroll();
        this.updateCompactDisplay();
        this.compactObserver = new MutationObserver(() => this.updateCompactDisplay());
        this.compactObserver.observe(this, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'data-preorder'] });
        document.body.addEventListener('change', this.handleVariantChange);
    }

    disconnectedCallback() {
        this.compactObserver?.disconnect();
        window.removeEventListener("scroll", this.handleScroll);
        window.removeEventListener("resize", this.handleScroll);
        document.body.removeEventListener('change', this.handleVariantChange);
    }

    updateCompactDisplay() {
        this.querySelectorAll('.selected-variant-option').forEach(option => {
            let value = option.textContent.trim().split(':').slice(1).join(':').trim();
            if (!value) return;
            const isoSize = value.match(/^(A[0-6])(?:\s|$)/i);
            option.dataset.compact = isoSize ? isoSize[1].toUpperCase() : value.split(' / ')[0].trim();
        });
        this.querySelectorAll('.price-item').forEach(price => {
            const value = price.textContent.trim();
            if (!value) return;
            price.dataset.compactPrice = this.dataset.currency === 'EUR' ? value.replace(/\s*EUR\b/g, '').trim() : value;
        });
        const button = this.querySelector('.sticky-atc-button');
        const label = button?.querySelector(':scope > span');
        if (!label) return;
        if (!button.disabled && !button.hasAttribute('data-preorder') && label.textContent.trim() === this.dataset.fullAdd) {
            label.dataset.compactLabel = this.dataset.shortAdd;
        } else {
            delete label.dataset.compactLabel;
        }
    }

    getAbsoluteTop(element) {
        let top = 0;
        while (element) {
            top += element.offsetTop || 0;
            element = element.offsetParent;
        }
        return top;
    }

    handleScroll() {
        if (!this.targetElement) return;
        const header = document.querySelector('sticky-header');
        const headerSection = header?.closest('.shopify-section');
        const candidates = [header, headerSection, ...document.querySelectorAll('.wallify-sticky-promo, .wallify-promo-bar, .wallify-discount-bar')].filter(Boolean);
        let headerBottom = 0;
        candidates.forEach((element) => {
            const rect = element.getBoundingClientRect();
            if (rect.top <= 1 && rect.bottom > 0) headerBottom = Math.max(headerBottom, rect.bottom);
        });
        this.style.setProperty('--wallify-sticky-top', headerBottom + 'px');
        const target = this.targetElement.getBoundingClientRect();
        const footer = this.footerElement?.getBoundingClientRect();
        const shouldShow = target.bottom < headerBottom && (!footer || footer.top > window.innerHeight);
        this.classList.toggle('show', shouldShow);
    }

    updateStickyATCOption(optionName, optionValue) {
        const matches = optionName.match(/options\[(.+)\]/);
        if (matches && matches[1]) {
            optionName = matches[1];
        }

        const optionDisplay = this.querySelector('.selected-variant-option[data-option-name="' + optionName + '"]');
        if (optionDisplay) {
            const labels = JSON.parse(optionDisplay.dataset.valueLabels || '{}');
            optionDisplay.textContent = (optionDisplay.dataset.optionLabel || optionName) + ': ' + (labels[optionValue] || optionValue);
        }
    }

    handleVariantChange(event) {
        const target = event.target;
        const productSection = target.closest(`#MainProduct-${this.sectionId}`);
        if (!productSection) return;
        if (target.tagName === 'INPUT' || target.tagName === 'SELECT') {
            const optionName = target.name;
            const optionValue = target.tagName === 'INPUT' ? target.value : target.options[target.selectedIndex].textContent;
            this.updateStickyATCOption(optionName, optionValue);
        }
    }
}

if (!customElements.get('product-add-to-cart-sticky')) customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

